import { useState } from 'react'
// import {useParams} from 'react-router-dom'
import {Space, Divider} from 'antd'
import dayjs from 'dayjs'
import cn from 'clsx'
import styles from './VariationScheduleList.module.scss'
import useStore from 'base/store'
import {PermissionType} from 'common/types'
import {
  // Block,
  Text,
  Circle,
  Button, IconButton,
  Modal,
  ShowAllIcon, ShowLessIcon, PenIcon, CloseSecondIcon,
} from 'common/components'
import {createReport, formatDate as format0, formatMoney as formatMoney0} from 'common/helpers'
// import {ControllerReviewForm, useGetRequest, getMilestone} from '..'
import {IScheduleItem, IVariationScheduleListProps} from './VariationScheduleList.type'
import JournalItemForm from './VariationJournalItemForm'
import {useDeleteJournal} from '../api.journal'

const formatDate = (d:string) => (!!d) ? format0(d, 'third') : ' '
const formatMoney= (n:number) => (!!n) ? formatMoney0(n, {cents: true, prefix: false}) : ''

type ViewModeType = 'all'|'less'

const getReportData = (data: any[]) => (
  [...data]
)

export default function VariationScheduleList(props: IVariationScheduleListProps) {
  const permissions: PermissionType[] = useStore((state) => state.permissions)
  const isModalOpen = useStore((state) => state.isVariationJournalEntry2Open)
  const setModalOpen = useStore((state) => state.setVariationJournalEntry2Open)
  const handleModalOpen = () => setModalOpen(true)
  const handleModalClose = () => setModalOpen(false)
  const { request, title, data, journal } = props
  const [viewMode, setViewMode] = useState<ViewModeType>('less')

  const onSwitchViewMode = () => {
    setViewMode(
      (mode:ViewModeType) => ( (mode === 'all') ? 'less' : 'all' )
    )
  }

  // console.table(data)
  // console.table(journal)
  const onExport = () => {
    createReport(
      getReportData([
        ...(data || []),
        ...(journal || []),
      ].map((x: IScheduleItem) => {
        const xx = {...x}
        if (!!xx.uuid) delete xx.uuid
        return ({ ...xx })
      }).sort((a: IScheduleItem, b: IScheduleItem) => (
        (
          !a.date || !b.date ||
          !dayjs(a.date).isValid() ||
          !dayjs(b.date).isValid()
        ) ? 0 :
        dayjs(a.date).isBefore(b.date, 'day') ? -1 :
        dayjs(a.date).isAfter(b.date, 'day') ? 1 : 0
      ))),
      props.exTitle,
      `schedule-export`
    )
  }

  const openDate = !!request?.project?.openDate ? dayjs(request.project.openDate) : undefined
  const lastItem = !data?.length ? null : data.at(-1) // dayjs(request?.startDate)?.subtract(1,'d').format('YYYY-MM-DD')
  // console.log(openDate)
  // console.log(lastItem)
  // console.table(data)
  // console.log(journal)

  const isNotAllowed = 
    !props.permissionRequired || (!permissions?.includes(props.permissionRequired)) ||
    !props.statusRequired || (request?.status !== props.statusRequired)

  return (
    <>
      <div className={styles.root}>
        <div className={styles.title}>
          <Text size="lg" weight="bold">{title}</Text>
          <div className={styles.options}>
            <ButtonMode onClick={onSwitchViewMode} viewMode={viewMode} />
            <Button variant="secondary" onClick={onExport}>Export</Button>
          </div>
        </div>
        <ul className={styles.list}>
          <ListHeader />
          { data?.map((x: IScheduleItem, index:number) => (
            (index !== 0) ? null :
            <div key={index}>
              <ListItem item={x} type={!!x.hasTrans ? 'border':'hole'} />
            </div>
          )) }
          { (viewMode === 'less') &&
            <li className={styles['list-row']}>
              <Divider dashed>
                <ButtonMode onClick={onSwitchViewMode} viewMode={viewMode} noIcon />
              </Divider>
            </li>
          }
          { data?.map((x: IScheduleItem, index:number) => (
            (
              (index === 0) ||
              ((viewMode === 'less') && (lastItem?.date !== x.date))
            ) ? null :
            <div key={index}>
              <ListItem item={x} type={!!x.hasTrans ? 'border':'hole'} />
            </div>
          )) }
          { !!journal?.length && 
            <li className={styles['list-row']}>
              <Divider dashed>
                <Text size="xs" weight="demiBold" color="brown" >
                  Journal record
                </Text>
              </Divider>
            </li>
          }
          { journal?.map((x: IScheduleItem, index:number) => (
            <ListItem request={request} openDate={openDate.toDate()} key={index} type="journal" item={x} />
          )) }
        </ul>
        <li className={cn(styles['list-row'], styles['new-entry'])}>
        { !isNotAllowed &&
          <Button variant="secondary" onClick={handleModalOpen}>
            Add journal entry
          </Button>
        }
        </li>
      </div>
      <Modal
        title="Journal"
        width={486}
        open={isModalOpen}
        onCancel={handleModalClose}
      >
        <JournalItemForm
          // projectUuid={projectUuid}
          // loanValue={loanValue}
          // forecast={currentForecast}
          minDate={openDate.toDate()}
          request={request}
          onClose={handleModalClose}
        />
      </Modal>
    </>
  )
}

const ButtonMode = ({viewMode, onClick, noIcon}:{
  viewMode: ViewModeType;
  onClick: () => void;
  noIcon?: boolean;
}) => {
  return (
    <Button variant="secondary" type="text" onClick={onClick}>
      <Text size="xs" weight="demiBold" color="brown" className={styles['icon-btn']}>
        { !!noIcon ? null : 
          viewMode === 'less' ? <ShowAllIcon /> : <ShowLessIcon /> 
        }
        <span>
          { viewMode === 'less' ? 'Show all' : 'Show less' }
        </span>
      </Text>
    </Button>
  )
}

const ListHeader = () => (
  <li className={cn(styles['list-row'], styles.header)}>
    <Text color="grayer" size="2xs" weight="demiBold">Reference</Text>
    <Text color="grayer" size="2xs" weight="demiBold">date</Text>
    <Text color="grayer" size="2xs" weight="demiBold" className={styles.money}>debit</Text>
    <Text color="grayer" size="2xs" weight="demiBold" className={styles.money}>Credit</Text>
    <Text color="grayer" size="2xs" weight="demiBold" className={styles.money}>balance</Text>
    <div></div>
    <Text color="grayer" size="2xs" weight="demiBold">Note</Text>
  </li>
)

const ListItem = ({openDate, request, item, type}:{
  openDate?: Date
  request?:any
  item: IScheduleItem;
  type?: 'border' | 'hole' | 'journal';
}) => {
  const [isOpen, setOpen] = useState(false)
  const handleModalOpen = () => setOpen(true)
  const handleModalClose = () => setOpen(false)
  const {mutate: deleteJournal} = useDeleteJournal()

  const onDelete = () => {
    if (!!item?.uuid) {
      deleteJournal({
        uuid: item.uuid
      })
    } else {
      alert('Uuid absent!')
    }
  }
  return (
  <li className={cn(styles['list-row'])}>
    <div className={styles.dot}>
    { (type === 'border') ?
      <Circle border color="green" />
      :
      <Circle hole color="green" />
    }
    </div>
    <div className={cn(styles.item)}>
      <Text color="black" size="md" weight="demiBold">{item.reference || ''}</Text>
      <Text color="black" size="md">{formatDate(item.date)}</Text>
      <Text color="black" size="md" className={styles.money}>{formatMoney(item.debit)}</Text>
      <Text color="black" size="md" className={styles.money}>{formatMoney(item.credit)}</Text>
      <Text color="black" size="md" className={styles.money}>{formatMoney(item.balance)}</Text>
      <div></div>
      <Text color="grayer50" size="md" >{item.note || ' '}</Text>

      { (type === 'journal') &&
        <Space className={styles.actions} size={0}>
          <IconButton
            className={styles.action}
            icon={<PenIcon />}
            onClick={handleModalOpen}
          />
          <IconButton
            className={styles.action}
            icon={<CloseSecondIcon />}
            loading={false} // {isDeleteMutating || isUpdateForecastMutating}
            // disabled={isRemoveDisabled}
            onClick={onDelete}
          />
        </Space>
      }
    </div>
    { (type === 'journal') &&
      <Modal
        title="Journal"
        width={486}
        open={isOpen}
        onCancel={handleModalClose}
      >
        <JournalItemForm
          // projectUuid={projectUuid}
          // loanValue={loanValue}
          // forecast={currentForecast}
          item={item}
          minDate={openDate}
          request={request}
          onClose={handleModalClose}
        />
      </Modal>
    }
  </li>
  )
}